import type { FC } from 'react';
import styled from 'styled-components';
import { Form as AntdForm, type FormProps, type FormItemProps as AntdFormItemProps } from 'antd';

const { Item, ErrorList, List, Provider, useForm, useFormInstance, useWatch } = AntdForm;

// NOTE: Some styles are hardcoded due to inconsistency in commons theme
const StyledForm = styled(AntdForm)<FormProps>`
  .ant-divider-vertical {
    margin: 0;
    height: auto;
  }
  .ant-divider-horizontal {
    margin: 0;
    height: auto;
  }
  .ant-form-item-label {
    padding: 0 0 3px 0;
  }
  .ant-form-item-label > label {
    font-size: ${({ theme }) => `${theme.font.typography.metadata.fontSize}px`};
    font-weight: ${({ theme }) => theme.font.typography.metadata.fontWeight.regular};
    line-height: ${({ theme }) => `${theme.font.typography.metadata.lineHeight}px`};
    letter-spacing: 0px;
    text-align: left;
    color: #6c7382;
  }

  /* .ant-form styles from FilterLayout */
  display: flex;
  gap: 16px;
  flex-wrap: wrap;

  .ant-form-item:not(.filter-control) {
    width: 200px;
    min-width: 200px;
    margin-bottom: 0;
  }

  @media (max-width: 1600px) {
    gap: 8px;
    .ant-form-item:not(.filter-control) {
      width: 150px;
      min-width: 150px;
    }
  }

  @media (max-width: 576px) {
    .ant-form-item {
      flex-direction: row;
    }
  }

  .ant-select-single .ant-select-selector .ant-select-selection-item {
    line-height: 28px;
  }
`;

export type FormItemProps = AntdFormItemProps;

/**
 * Ant Design Form Component
 * Styled for Filter
 */
export function FilterForm<T>(props: FormProps<T>): JSX.Element {
  return <StyledForm<FC<FormProps<T>>> {...props} layout="vertical" />;
}

FilterForm.Item = Item;
FilterForm.useForm = useForm;
FilterForm.useFormInstance = useFormInstance;
FilterForm.useWatch = useWatch;
FilterForm.ErrorList = ErrorList;
FilterForm.List = List;
FilterForm.Provider = Provider;
